import React from 'react';
import Style from './index.module.scss';
import {message, Modal, Table, TableColumnsType} from 'antd';
import {
    downloadLog,
    getImportLog,
    ImportStatus,
    LogItem,
    WindowProps,
} from '../../service';
import useRequest from '../../../../Utils/Hooks/useRequest';
import {CheckCircleOutlined, WarningOutlined} from '@ant-design/icons';
import usePagination from '../../../../Utils/Hooks/usePagination';
import useRequestFn from '../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../Utils/common';
import {isEmpty} from '../../../../Stores/commonStore';

export interface Props extends WindowProps {}
export default function Index({logUrl, downloadUrl, ...restProps}: Props) {
    const [dataSource, {loading}] = useRequest(() => getImportLog(logUrl), {}, [
        logUrl,
    ]);

    const pagination = usePagination();

    // 导出
    const [onExport, {loading: downloadLoadling}] = useRequestFn(downloadLog);
    async function downLoadFile(id: string) {
        try {
            await onExport(downloadUrl, {id});
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const columns: TableColumnsType<LogItem> = [
        {
            dataIndex: 'createTime',
            title: '导入时间',
            width: '50%',
        },
        {
            title: '结果',
            width: '50%',
            render: (text, item) => {
                if (item.status === ImportStatus.Success) {
                    return (
                        <span className={Style.success}>
                            <CheckCircleOutlined />
                            导入成功
                        </span>
                    );
                } else {
                    return (
                        <span className={Style.error}>
                            <WarningOutlined />
                            导入失败
                            {!isEmpty(downloadUrl) && (
                                <span
                                    className={Style.down}
                                    onClick={() => downLoadFile(item.id)}>
                                    (点击查看原因)
                                </span>
                            )}
                        </span>
                    );
                }
            },
        },
    ];
    return (
        <Modal
            title="导入结果"
            maskClosable={false}
            {...restProps}
            width={650}
            footer={null}
            className={Style.root}>
            <div className={Style.body}>
                <Table
                    size="small"
                    rowKey="id"
                    {...pagination.tableProps(dataSource?.total)}
                    loading={loading || downloadLoadling}
                    columns={columns}
                    dataSource={dataSource?.data}
                />
            </div>
        </Modal>
    );
}
